export default __webpack_public_path__ + "static/media/0053_IMG3850.b27f5822.jpg";